<script setup>
import { ref, onMounted } from "vue";
import Split from "split.js";
import MainPage from "./MainPage.vue";
import DrawPlot from "./DrawPlot.vue";

const selectedFileIds = ref([]); // Stores selected file IDs
const matchSession = ref(null);

// Function to update selected files and trigger plot update.
const updatePlot = (ids) => {
  selectedFileIds.value = ids;
};

const updateMatches = (session) => {
  matchSession.value = session;
};

const closeMatches = () => {
  matchSession.value = null;
};

// Create refs for the left and right panels.
const leftPanel = ref(null);
const rightPanel = ref(null);

onMounted(() => {
  // Ensure the panels exist before initializing Split.js.
  if (leftPanel.value && rightPanel.value) {
    Split([leftPanel.value, rightPanel.value], {
      sizes: [35, 65], // initial sizes in percentages
      minSize: [200, 300], // minimum pixel sizes for each panel
      gutterSize: 10, // width of the draggable divider
      cursor: "col-resize",
    });
  }
});
</script>

<template>
  <!-- Adjust the height by subtracting the top bar height (e.g., 64px) -->
  <div class="flex h-full min-h-0 overflow-hidden">
    <div ref="leftPanel" class="h-full min-h-0 overflow-auto bg-white">
      <MainPage @draw="updatePlot" @matches-found="updateMatches" />
    </div>
    <div ref="rightPanel" class="h-full min-h-0 overflow-hidden bg-white">
      <DrawPlot
        :selectedIds="selectedFileIds"
        :matchSession="matchSession"
        @close-matches="closeMatches"
        @matches-updated="updateMatches"
      />
    </div>
  </div>
</template>

<style>
.gutter {
  background-color: #eee; /* Light gray background */
  background-repeat: no-repeat;
  background-position: 50%;
}

.gutter.gutter-horizontal {
  cursor: col-resize;
}
</style>
